module.exports = __webpack_public_path__ + "static/media/about.9d2b064d.mp4";